import React, { ReactElement, useState } from 'react';
import { withWrapper } from '@shared/react';
import {
    OrderTableProvider,
    useOrderTable,
    getOrderTableColumns,
    UserManagement_TABLE_TITLE,
    UserManagement_TABLE_INFO_URL,
    getOrderTableRows,
    UserManagement_TABLE_TITLE_RIA,
} from './lib';
import { Table } from '@features/Table';
import './OrderTable.scss';
import { OrderTableFilters } from './components/OrderTableFilters';
import { Card } from '@shared/UI';
import classNames from 'classnames';

const tabsContent: any = {
    RIA: 'RIA',
    Client: 'Client',
};

const OrderTableContent: React.FC = () => {
    const { OrderBody, paginationOptions, onOrderRowClick, onAssignPositionClick, orderLoading, setRiaScreen } =
        useOrderTable();
    const userStorage = localStorage.getItem('User');
    let userObject: any = null;
    userObject = JSON.parse(userStorage ? userStorage : '');

    let initialTab = 'RIA';
    const [selectedTab, setSelectedTab] = useState<keyof any>(initialTab ? initialTab : Object.keys(tabsContent)[0]);
    return userObject ? (
        <Table
            columns={getOrderTableColumns()}
            data={OrderBody}
            dataLoading={orderLoading}
            tableTitle={UserManagement_TABLE_TITLE_RIA}
            infoLink={UserManagement_TABLE_INFO_URL}
            paginationOptions={paginationOptions}
            row={getOrderTableRows({ onOrderRowClick })}
            showButton={true}
            filters={<OrderTableFilters onAssignPositionClick={onAssignPositionClick} />}
            tableToShow='showTable'
        />
    ) : (
        <Card className={'tabs-container'}>
            <div style={{ display: 'flex', marginLeft: '20px' }}>
                <ul className={'tabs'}>
                    {Object.keys(tabsContent).map((tabName) => (
                        <li
                            key={tabName}
                            className={classNames('tabs__item', { 'tabs__item--active': tabName === selectedTab })}
                            onClick={() => {
                                setSelectedTab(tabName);
                                if (tabName === 'RIA') {
                                    setRiaScreen(true);
                                } else {
                                    setRiaScreen(false);
                                }
                            }}
                        >
                            {tabName}
                        </li>
                    ))}
                </ul>
            </div>
            <Table
                columns={getOrderTableColumns()}
                data={OrderBody}
                dataLoading={orderLoading}
                tableTitle={UserManagement_TABLE_TITLE}
                infoLink={UserManagement_TABLE_INFO_URL}
                paginationOptions={paginationOptions}
                row={getOrderTableRows({ onOrderRowClick })}
                showButton={true}
                filters={<OrderTableFilters onAssignPositionClick={onAssignPositionClick} />}
                tableToShow='showTable'
            />
        </Card>
    );
};

export const OrderTable = withWrapper(OrderTableProvider)(OrderTableContent);
